import { render, staticRenderFns } from "./FavoriteMessageChat.vue?vue&type=template&id=d0855692&"
import script from "./FavoriteMessageChat.vue?vue&type=script&lang=js&"
export * from "./FavoriteMessageChat.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteMessageChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports